import { Container, Typography } from '@cleartrip/ct-design-components'
import React from 'react'

import LayoverPath from '@/assets/icons/LayoverPath'
import {
    LongLayoverBlock,
    ShortLayoverBlock,
    TechnicalLayoverBlock
} from '@/components/srp/FlightDetails/FlightItinerary/LayOverTypes'

interface LayoverProps {
    length: number
    index: number
    duration: {
        hh: number
        mm: number
        totalMinutes: number
    }
    transitVisaRequired: boolean
    changeInfo?: { message: string; airportChange: boolean; terminalChange: boolean }
    isIntl?: boolean
    isTechnicalLayover?: boolean
}

const Layover = ({
    length,
    index,
    duration,
    transitVisaRequired = false,
    changeInfo,
    isIntl = false,
    isTechnicalLayover = false
}: LayoverProps) => {
    const DOM_LAYOVER_TIME_IN_MIN = isIntl ? 240 : 120
    const { hh: hours, mm: minutes, totalMinutes } = duration

    const callouts: { text: string }[] = []
    if (isTechnicalLayover) {
        callouts.push({ text: 'Deboarding may not be allowed' })
    }
    if (transitVisaRequired) {
        callouts.push({ text: 'Transit visa may be required' })
    }
    if (changeInfo?.message) {
        callouts.push({ text: changeInfo?.message })
    }

    const getLayoverBlock = () => {
        if (isTechnicalLayover) return <TechnicalLayoverBlock />
        return totalMinutes < DOM_LAYOVER_TIME_IN_MIN ? <ShortLayoverBlock /> : <LongLayoverBlock />
    }

    return length - 1 > index ? (
        <Container
            className="flex flex-middle"
            style={{
                background: '#F3F3F3',
                paddingLeft: '48px'
            }}
        >
            <Container className="flex flex-right" style={{ width: '60px' }}>
                <Typography color="subheading" variant="B3">
                    {hours}h {minutes}m
                </Typography>
            </Container>
            <Container className="flex flex-center" style={{ width: '43px' }}>
                <LayoverPath />
            </Container>
            <Container className="flex flex-column ml-4">
                {getLayoverBlock()}
                {callouts.map(callout => (
                    <p className="mt-1" key={callout.text}>
                        <span className="fs-3 fw-600" style={{ color: '#C83232' }}>
                            {callout?.text}
                        </span>
                    </p>
                ))}
            </Container>
        </Container>
    ) : (
        <></>
    )
}

export default Layover
